const reportWebVitals = onPerfEntry => {
  // Temporarily disabled due to missing web-vitals dependency
  // To fix this error, run: npm install web-vitals
  console.log('Web vitals reporting is disabled. Install web-vitals to enable.');
  
  // Original code commented out until web-vitals is installed
  /*
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
  */
};

export default reportWebVitals;
